export const ROLES = {
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super Admin',
  BRANCH_MANAGER: 'Branch Manager',
  LOAN_OFFICER: 'Loan Officer',
  CREDIT_ANALYST: 'Credit Analyst',
  CREDIT_MANAGER: 'Credit Manager',
  COLLECTION_OFFICER: 'Collection Officer',
  FIELD_OFFICER: 'Field Officer',
  GENERAL_MANAGER: 'General Manager',
  IT_ADMIN: 'IT Admin',
  AUDITOR: 'Auditor',
};

// ═══════════════════════════════════════════════════════════
// Lead status flow:
// new → contacted → interested → qualified → onboarding → converted
//                                                     ↘ lost
//                                                     ↘ unqualified
//
// 'onboarding' = user started Step 1 but hasn't submitted
// 'converted'  = all 8 steps done and submitted for approval
// ═══════════════════════════════════════════════════════════
export const LEAD_STATUS_MAP = {
  new: 'info',
  contacted: 'warning',
  interested: 'info',
  qualified: 'success',
  unqualified: 'secondary',
  converted: 'success',
  lost: 'danger',
  onboarding: 'info',
};

// ═══════════════════════════════════════════════════════════
// FIX: Added 'onboarding' to CLIENT_STATUS_MAP.
//
// Client status flow:
// onboarding → pending-approval → pending-manager-review → approved
//                                                          ↘ rejected
//                                                          ↘ deactivated
//                                                          ↘ blacklisted
//
// 'onboarding' = client record created but Steps 1-8 not yet
//   submitted. These do NOT appear on admin approval page.
// 'pending-manager-review' = fully submitted, awaiting admin.
//   These DO appear on the approval page.
// ═══════════════════════════════════════════════════════════
export const CLIENT_STATUS_MAP = {
  onboarding: 'info',
  'pending-approval': 'warning',
  'pending-manager-review': 'warning',
  'returned-for-modification': 'warning',
  approved: 'success',
  rejected: 'danger',
  blacklisted: 'danger',
  inactive: 'secondary',
  dormant: 'warning',
  deactivated: 'secondary',
};

export const LOAN_APP_STATUS_MAP = {
  draft: 'secondary',
  submitted: 'info',
  'under-review': 'warning',
  approved: 'success',
  rejected: 'danger',
  disbursed: 'success',
};

export const LOAN_STATUS_MAP = {
  active: 'success',
  overdue: 'danger',
  defaulted: 'danger',
  closed: 'secondary',
  'written-off': 'danger',
};

export const PAYMENT_METHODS = ['cash', 'bank-transfer', 'mobile-money', 'cheque', 'card'];